import { getIsIntroductionSkipped, setSkipIntroduction } from '../shared/preferences';
import { getMetadata, setMetadata } from '../shared/metadata';
import { DialogTypes, TimerMetaData } from '../shared/types';

export function setTimerMetaData(
  presentationId: string,
  slideId: string,
  metadata: Partial<TimerMetaData>,
  shouldCallApi: boolean = true
) {
  setMetadata(presentationId, slideId, { timer: metadata }, shouldCallApi);
}

export function getTimerMetaData(presentationId: string, slideId: string) {
  const data = getMetadata(presentationId, slideId, 'timer');
  return data;
}

export function setTimerSkipIntroduction(value: boolean) {
  setSkipIntroduction(DialogTypes.TIMER, value);
}

export function getIsTimerIntroductionSkipped() {
  return getIsIntroductionSkipped(DialogTypes.TIMER);
}
